import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Edit2 = createReactComponent("Edit2", ["svg", defaultAttributes, [["path", {
  d: "M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z",
  key: "7yj3lx"
}]]]);
export default Edit2;